import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www-local/frontend/lides/lides-sk-01/components/projects/Gallery.jsx");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/grandus-lib/components-atomic/MicroData.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/public/assets/icons/house.png");
